import { useState, useEffect } from 'react'
import throttle from 'lodash/throttle'
import { isServer } from 'utils/environment'

const useViewportHeight = (): number => {
  const [viewportHeight, setViewportHeight] = useState<number>(() =>
    isServer() ? 0 : window.innerHeight
  )

  useEffect(() => {
    const updateViewportHeight = () => setViewportHeight(window.innerHeight)

    updateViewportHeight()
    const throttledUpdate = throttle(updateViewportHeight, 50)
    window.addEventListener('resize', throttledUpdate)

    return () => {
      window.removeEventListener('resize', throttledUpdate)
      throttledUpdate.cancel()
    }
  }, [])

  return viewportHeight
}

export default useViewportHeight
